class MembersPortal extends HTMLElement {
  connectedCallback() {
    this._navBtns = this.querySelectorAll('[data-nav]')
    this._panels = this.querySelectorAll('.panel')
    this._titleEl = this.querySelector('#members-page-title')
    this._searchEl = this.querySelector('#members-search')
    this._bellBtn = this.querySelector('#bell-btn')
    this._mobBtn = this.querySelector('#mob-menu-btn')
    this._sidebar = this.querySelector('#members-sidebar')
    this._backdrop = this.querySelector('#sb-backdrop')

    // Build locale-aware panel title map from nav button text nodes
    this._titles = {}
    this._navBtns.forEach((btn) => {
      const id = btn.dataset.nav
      let text = ''
      btn.childNodes.forEach((node) => {
        if (node.nodeType === 3) text += node.textContent
      })
      this._titles[id] = text.trim()
    })

    this._navBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (this._searchEl) this._searchEl.value = ''
        this.showPanel(btn.dataset.nav)
      })
    })

    if (this._bellBtn) this._bellBtn.addEventListener('click', () => this.showPanel('announcements'))
    if (this._mobBtn) this._mobBtn.addEventListener('click', this._openSidebar)
    if (this._backdrop) this._backdrop.addEventListener('click', this._closeSidebar)
    this.addEventListener('click', this._handleFilterClick)
    // if (this._searchEl) this._searchEl.addEventListener('input', this._handleSearch)
  }

  showPanel = (id) => {
    this._panels.forEach((p) => p.classList.remove('active'))
    this._navBtns.forEach((b) => b.classList.remove('active'))

    const panel = this.querySelector(`#panel-${id}`)
    const btn = this.querySelector(`[data-nav="${id}"]`)

    if (panel) panel.classList.add('active')
    if (btn) btn.classList.add('active')
    if (this._titleEl) this._titleEl.textContent = this._titles[id] || id

    const bodyEl = this.querySelector('#members-body')
    if (bodyEl) bodyEl.scrollTop = 0

    if (panel) {
      const fg = panel.querySelector('.filters')

      if (fg) {
        fg.querySelectorAll('.fchip').forEach((c) => c.classList.remove('active'))
        const allChip = fg.querySelector('[data-filter="all"]')
        if (allChip) allChip.classList.add('active')
        this._filterCards(panel, '')
      }
    }

    this._closeSidebar()
  }

  _openSidebar = () => {
    if (this._sidebar) this._sidebar.classList.add('open')
    if (this._backdrop) this._backdrop.classList.add('open')
  }

  _closeSidebar = () => {
    if (this._sidebar) this._sidebar.classList.remove('open')
    if (this._backdrop) this._backdrop.classList.remove('open')
  }

  _handleFilterClick = (e) => {
    if (!e.target.classList.contains('fchip')) return
    const chip = e.target
    const fg = chip.closest('.filters')
    if (!fg) return
    fg.querySelectorAll('.fchip').forEach((c) => c.classList.remove('active'))
    chip.classList.add('active')
    const panel = chip.closest('.panel')
    if (panel) this._filterCards(panel, this._searchEl ? this._searchEl.value.toLowerCase().trim() : '')
  }

  _filterCards = (panel, query) => {
    const grid = panel.querySelector('.doc-grid')
    if (!grid) return
    const fg = panel.querySelector('.filters')
    const activeChip = fg ? fg.querySelector('.fchip.active') : null
    const filter = activeChip ? activeChip.dataset.filter : 'all'
    let visible = 0

    grid.querySelectorAll('.doc-card').forEach((card) => {
      let show = true
      if (filter && filter !== 'all') {
        const [type, val] = filter.split(':')
        if (type === 'cat' && card.dataset.cat !== val) show = false
        if (type === 'linha' && card.dataset.linha !== val) show = false
      }
      if (query) {
        const t = (card.dataset.title || '').toLowerCase()
        const d = (card.dataset.desc || '').toLowerCase()
        if (!t.includes(query) && !d.includes(query)) show = false
      }
      card.toggleAttribute('aria-hidden', !show)
      if (show) visible++
    })

    const filterEmptyEl = grid.querySelector('.members-empty-state')
    if (filterEmptyEl) filterEmptyEl.toggleAttribute('aria-hidden', visible > 0)
  }

  _handleSearch = () => {
    const q = this._searchEl.value.toLowerCase().trim()
    if (q) {
      this._panels.forEach((p) => p.classList.remove('active'))
      this._navBtns.forEach((b) => b.classList.remove('active'))
      const bibPanel = this.querySelector('#panel-library')
      const bibBtn = this.querySelector('[data-nav="library"]')
      if (bibPanel) bibPanel.classList.add('active')
      if (bibBtn) {
        bibBtn.classList.add('active')
        if (this._titleEl) this._titleEl.textContent = this._titles['library'] || ''
      }
    }
    const activePanel = this.querySelector('.panel.active')
    if (activePanel) this._filterCards(activePanel, q)
  }
}

if (!window.customElements.get('members-portal')) {
  window.customElements.define('members-portal', MembersPortal)
}
